const elementary = require('../vendor/elementary.js');

const selector = "[data-tab-panel]";
const moConfig = {
	attributes: true,
	attributeFilter: ["data-tabs-active"]
} 

let els = null;

function TabPanels() {

	// Search for tab panel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Loop through them
	[].forEach.call(els, function(item) {

		// Get this panels, parent tabs elements
		const parentTabsEl = item.closest("[data-tabs]");

		// Create new observer watching for attribute changes on tabs element
		const obs = new MutationObserver(checkIsActive);
		obs.observe(parentTabsEl, moConfig);
	});
}

// Observer callback
const checkIsActive = (mutationsList) => {

	// For each observed mutation
	mutationsList.forEach((mutation) => {

		// Get mutated element and the "data-tabs-active" attribute from it
		const el        = mutation.target;
		const activeTab = el.dataset.tabsActive;

		// Loop through all tab panels inside this element
		[].forEach.call(el.querySelectorAll(selector), function(item) {

			// Get panel id and set default attributes
			const itemId   = item.dataset.tabPanel;
			let ariaHidden = true;
			let tabIndex   = "-1";

			// Change attributes if panel id matches active tab in this tabs component
			if (itemId == activeTab) {
				ariaHidden = false;
				tabIndex   = "0";
			}

			// Set attributes on the panel
			item.setAttribute("aria-hidden", ariaHidden);
			item.setAttribute("tabindex", tabIndex);
		});

		elementary();
	});
}

export default TabPanels;